<template>
  <el-dialog
    title="配置合格证书"
    :visible.sync="dialogVisible"
    width="60%"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
  >
    <el-form :model="form" :rules="rule" ref="form">
      <el-form-item
        label="培训班名称"
        :label-width="formLabelWidth"
      >
        <el-input
          readonly
          v-model="editParams.name"
          autocomplete="off"
          placeholder="请输入培训班名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="证书选择" :label-width="formLabelWidth" prop="qualityId">
        <el-select v-model="form.qualityId" @change='change'>
          <el-option v-for="(item,idx) in selectJson" :key="idx" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <div class="red">
        请谨慎选择合格证模版，如果更换合格证模版，请在培训班通讯录中，为学员重新生成合格证
      </div>
      <el-form-item label="证书样例" :label-width="formLabelWidth">
        <img :src="imgUrl" alt="" style="max-width:300px">
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="sure">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { addQuality,getCertificateInfo } from '@/api/api'
export default {
  components: {},
  props: {
    editParams: {
      type: Object,
      default: function(){
        return {}
      }
    }
  },
  data() {
    return {
      imgUrl:'',
      dialogVisible: false,
      formLabelWidth: "130px",
      selectJson:[
        {
          label:'123',
          value:'0'
        }
      ],
      form: {},
      rule: {
        qualityId: [{ required: true, message: "请选择证书类型", trigger: "blur" }],
      },
    };
  },
  methods: {
    change(id){
      console.log(id)
        this.selectJson.map((item)=>{
          if( item.id == id ){
            this.imgUrl = item.templateUrl
          }
        })
    },
    setOpacity(flg) {
      this.getData();
      this.dialogVisible = flg;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    getData(){
      getCertificateInfo({
        templateType : 2
      }).then(res => {
        let { code,data, message } = res;
        if (code === 0) {
          this.selectJson = data;
          this.change(this.form.qualityId)
        } else {
          this.$message.error(message);
        }
      })
    },
    sure(){
      this.$refs.form.validate(async (valid) => {
          if (valid) {
            addQuality({
              id: this.editParams.id,
              ...this.form
            }).then(res => {
              let { code, message } = res;
              if (code === 0) {
                this.$emit('success')
                this.$message.success('配置成功');
                this.dialogVisible = false
              } else {
                this.$message.error(message);
              }
            })
          }
      })
      
    }
  },
  watch: {
    editParams: {
      immediate: true,
      handler(newValue, oldValue) {
        if( newValue ){
          this.imgUrl = ''
          if( this.editParams.qualityId !== undefined ){
            this.form.qualityId = Number(this.editParams.qualityId)
          }else{
            this.form = {}
          }
        }
        
      },
    },
  },
};
</script>

<style lang="scss">
.w50 {
  width: 50%;
  display: inline-block;
}
.el-dialog__body {
  // max-height: 50vh;
  overflow-y: auto;
}
</style>
